import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './MobileNavBar.css';
import { MobileNavBarCategory } from '../MobileNavBarCategory';
import { ConnectedMobileNavBarSubCategory } from '../MobileNavBarSubCategory';
import {
  MORE_CATEGORY,
  HELP_SUBCATEGORY,
  LOGOUT_SUBCATEGORY,
  SETTINGS_USER_SUBCATEGORY,
  ACCOUNT_PASSWORD_SUBCATEGORY,
  ACCOUNT_PROFILE_SUBCATEGORY,
} from '../NavBar/navConstants';

// eslint-disable-next-line react/prefer-stateless-function
export class MobileNavBar extends Component {
  render() {
    const {
      utilities = [],
      activeCategory = {},
      selectedCategory = {},
      selectedSubCategory = {},
      isUserManager,
    } = this.props;

    const activeUtility = utilities.find((utility) => utility.name === activeCategory.name);
    let subCategories = null;
    let subCategoriesList = [ACCOUNT_PROFILE_SUBCATEGORY, ACCOUNT_PASSWORD_SUBCATEGORY];

    if (isUserManager) {
      subCategoriesList.push(SETTINGS_USER_SUBCATEGORY);
    }

    subCategoriesList = [...subCategoriesList, HELP_SUBCATEGORY, LOGOUT_SUBCATEGORY];

    if (activeUtility) {
      subCategories = (
        <ConnectedMobileNavBarSubCategory
          category={activeUtility}
          subCategories={activeUtility.sub_categories}
          selectedCategory={selectedCategory}
          selectedSubCategory={selectedSubCategory}
          onClick={this.props.onClick}
        />
      );
    }

    if (activeCategory.name === 'More') {
      subCategories = (
        <ConnectedMobileNavBarSubCategory
          category={MORE_CATEGORY}
          subCategories={subCategoriesList}
          selectedCategory={selectedCategory}
          selectedSubCategory={selectedSubCategory}
          onClick={this.props.onClick}
        />
      );
    }

    return (
      <div className="nav-bar-list-mobile">
        <ul className="nav-bar-list">
          {utilities.map((utility) => (
            <MobileNavBarCategory
              key={utility.id}
              isActive={activeCategory.name === utility.name}
              category={utility}
              selectedCategory={selectedCategory}
              selectedSubCategory={selectedSubCategory}
              onClick={this.props.onClick}
            />
          ))}
          <MobileNavBarCategory
            isActive={activeCategory.name === 'More'}
            category={MORE_CATEGORY}
            selectedCategory={selectedCategory}
            selectedSubCategory={selectedSubCategory}
            onClick={this.props.onClick}
          />
        </ul>
        {this.props.activeCategory ? subCategories : null}
      </div>
    );
  }
}

MobileNavBar.propTypes = {
  activeCategory: PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    name: PropTypes.string,
    sub_categories: PropTypes.array,
    url: PropTypes.string,
  }),
  onClick: PropTypes.func.isRequired,
  selectedCategory: PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    name: PropTypes.string,
    sub_categories: PropTypes.arrayOf(
      PropTypes.shape({
        api_location: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
    url: PropTypes.string,
  }).isRequired,
  selectedSubCategory: PropTypes.shape({
    api_location: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  utilities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      image: PropTypes.string,
      name: PropTypes.string,
      sub_categories: PropTypes.array,
      url: PropTypes.string,
    }),
  ).isRequired,
};

MobileNavBar.defaultProps = { activeCategory: undefined, isUserManager: false };
